module.exports = __webpack_public_path__ + "img/couples-031.371d8894.jpg";